export const environment = {
    urlBase:"https://data.recaudarsinu.com",
    frontendUrl: "https://recaudarsinu.com"
}
